// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"22b77912","455":"f42e9a09","977":"be192063"}[chunkId] + ".chunk.js";
};